import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/assemblies/add-assembly')({
    // Only redirects: the new page checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ assemblyId: 'required', rfqId: 'required' }),
    // The parent assembly moved from `?assemblyId=` into the path of `$assemblyId/subassemblies/create`.
    beforeLoad: ({ search }) => {
        throw redirect({
            to: '/assemblies/$assemblyId/subassemblies/create',
            params: { assemblyId: search.assemblyId },
            search: { rfqId: search.rfqId },
            replace: true,
        });
    },
});
